import React, { useState, useEffect } from 'react';
import { Provider } from 'react-redux';
import store from '../../flux/store';
import LoginForm from '../../components/auth/LoginForm';
import { css } from "@emotion/core";
import PuffLoader from "react-spinners/PuffLoader";

export default function LoginPage() {
  const [srcLoaded, setSrcLoaded] = useState(false);
  const IMAGE_SRC = '/images/bg.jpg';

  const img = new Image();
  img.src = IMAGE_SRC;
  img.onload = () => setSrcLoaded(true);

  // useEffect(() => {
  //   document.body.style.overflowY = "unset"
  //   return () => document.body.style.overflowY = "scroll"
  // });

  return srcLoaded ? <div className="auth_container" style={{backgroundImage: `url('${IMAGE_SRC}')`}}>
      <div className="auth_overlay_bg"></div>
      <div className="auth_wrapper">
        <div className="auth_inner">
          <LoginForm />
        </div>
      </div>
    </div> : <div className="sweet-loading-modal">
      <PuffLoader
        css={css`
          display: flex;
          margin: 0 auto;
        `}
        size={150}
        color={"#62af42"}
        loading={true}
      />
    </div>;
}
